import React, { createContext, useState, useContext } from 'react';
import Toaster from './components/Toaster/Toaster';

const ToasterContext = createContext();

export const useToaster = () => useContext(ToasterContext);

export const ToasterProvider = ({ children }) => {
    const visibleDuration = 3000;
    const [toast, setToast] = useState({ message: '', type: '', visible: false, duration: visibleDuration });

    const showToaster = (message, type = 'success') => {
        setToast({ message, type, visible: true, duration: visibleDuration });
    };

    const hideToaster = () => {
        setToast({ message: '', type: '', visible: false, duration: visibleDuration });
    };

    const value = {
        toastSuccess: (message) => showToaster(message, 'success'),
        toastError: (message) => showToaster(message, 'error'),
        toastWarning: (message) => showToaster(message, 'warning'),
        hide: hideToaster,
    };

    return (
        <ToasterContext.Provider value={value}>
            {children}
            {toast.visible && (
                <Toaster
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    onClose={hideToaster}
                    position={{ top: '80px', right: '20px' }}
                />
            )}
        </ToasterContext.Provider>
    );
};
